import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, Inject, PLATFORM_ID, OnDestroy, ViewChildren,ViewChild, ElementRef, QueryList } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
//import $ from 'jquery';

import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Subject } from 'rxjs';
import { error } from 'node:console';
import { Tooltip } from 'bootstrap'

@Component({
  selector: 'app-manager-resource-timesheet',
  standalone: true,
  imports: [CommonModule, TranslateModule, HttpClientModule, FormsModule, DatePickerModule],
  providers: [Base64UrlService],
  templateUrl: './manager-resource-timesheet.component.html',
  styleUrl: './manager-resource-timesheet.component.css'
})
export class ManagerResourceTimesheetComponent {
  @ViewChild('btntraining_history_popup') cngButton!: ElementRef;
  
  userName: any;
  lang: any;
  userCode: any;
  timeSheetTopPannel: any;
  monthDropdown: any;
  timeSheetData: any;
  timeSheetCmnData: any;
  jobOrderData: any;
  noteTypes: any;
  expensesTypes: any;
  timesheetId: any;
  timesheetIdOrg: any;
  userId: any;
  userIdOrg: any;
  editingRow: number | null = null;
  dashboard_msg: any;
  msgType: any;
  selectAll = false;
  selectedTimesheetId: number | string = '';
  isButtonDisabled: boolean = false;
  expandedRows: boolean[] = [];
  expandedRowsButton: boolean[] = [];
  thread_msg: any;
  trainingCommentsDis: string = '';
  trainingComments: string = '';
  archive: boolean = false;
  hourDropDown: string[] = [];
  endHourDropDown: string[] = [];
  minuteDropDown: string[] = []; 

  dashboard_err_msg: { row: number; message: string; disDate: string }[] = [];
  
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private route: ActivatedRoute, private auth: AuthService,private translate: TranslateService, private pageTitle: PageTitleService, private ts: TimesheetService, private en: EncryptionService, private http: HttpClient, private router: Router,
   private safeUrl: Base64UrlService, @Inject(PLATFORM_ID) private platformId: Object
  ) { 
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 

      this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
      console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    this.userCode = this.auth.getCode();
    if (isPlatformBrowser(this.platformId)) {
      // this.timesheetId = Base64UrlService.decode(this.en.decryptionAES(decodeURIComponent(this.route.snapshot.params['id'])));
      this.timesheetId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['id']));
      //  console.log(this.timesheetId);
     // this.timesheetId = decodeURIComponent(this.route.snapshot.params['id']);
      this.timesheetIdOrg = this.route.snapshot.params['id'];
      this.userId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['userId']));
      this.userIdOrg = this.route.snapshot.params['userId'];
      
      this.dashboard_msg = null;
      this.dashboard_msg = localStorage.getItem('dashboard_msg');    
      localStorage.removeItem('dashboard_msg');
      this.thread_msg = null;
    
      this.userName = this.auth.getName();
      this.pageTitle.setTitle('menu.timesheet');
      this.selectedTimesheetId = this.timesheetId;
      this.getMonthDropDown();
      this.getTimesheetData();
    }
  }

  @ViewChildren('tooltipEl', { read: ElementRef }) tooltipElements!: QueryList<ElementRef>;

  triggerClick() {
    this.cngButton.nativeElement.click();
  }

  ngAfterViewInit() {
    this.initTooltips();
    this.tooltipElements.changes.subscribe(() => this.initTooltips());
  }

  private initTooltips(): void {
    this.tooltipElements.forEach((el) => new Tooltip(el.nativeElement));
  }
  
  getShortText(text: string, limit: number = 30): string {
    return text && text.length > limit ? text.substring(0, limit) + '...' : text;
  }
    
  getMonthDropDown() {
    // this.ts.getMonthList()
    this.ts.getMonthWithTimesheetId()
    .subscribe({
      next: (resMonthList: any) => {
        if (resMonthList.status) {
          this.monthDropdown = resMonthList.data;          
        } else {
          this.dashboard_msg = "dataRetriveErrorMessage";
          this.msgType = "danger";           
          this.isButtonDisabled = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // console.log(this.monthDropdown);        
      },
      error: (err: any) => {        
        if (err.status == 401) {
          this.auth.logout();
		  return
        } else {
          this.dashboard_msg = "dataRetriveErrorMessage";
          this.msgType = "danger";           
          this.isButtonDisabled = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });
  }

  selectStartTime(i: number) {
    setTimeout(() => {
      const el: any = document.querySelector(
        `#startTime_${i} input`
      );
      if (el) {
        el.select();
        el.focus();
      }
    });
  }

  selectFinishTime(i: number) {
    setTimeout(() => {
      const el: any = document.querySelector(
        `#endTime_${i} input`
      );
      if (el) {
        el.select();
        el.focus();
      }
    });
  }
  
  chkNote(event: any, index: number) {
    const target = event.target as HTMLSelectElement;
    const noteId = target.value;   
    const item = this.timeSheetData[index];    
    if (noteId == '20' || noteId == '50') {
      item.startHour = '';
      item.startMinute = '';
      item.endHour = '';
      item.endMinute = '';
      item.midnightBreakMinutes = '';
      item.breakMinutes = '';
      item.expenseId = '0';
      item.cost = '';
      item.whf = false;
    }
  }

  chkSubmitCnt() {
    // console.log(chkStatus)
    const total = this.timeSheetData.length;
    const checked = this.timeSheetData.filter((item: any) => item.markedForSubmit).length;
    console.log(this.timeSheetData.length);
    console.log(this.timeSheetData.filter((item: any) => item.markedForSubmit).length);
    this.selectAll = (total > 0 && checked === total);
    
  }
  getTimeDiffInMinutes(start: string, end: string) {    
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    const diffMs = endTime - startTime;
    const diffMin = Math.floor(diffMs / (1000 * 60));    // convert to minutes
    let rt = this.addMinutesWithOverflow(start, diffMin).split('T')[1].split(':');
    let finalEndTime = `${parseInt(rt[0], 10)}:${rt[1]}`;
    return finalEndTime;
  }
  
  addMinutesWithOverflow(dateStr: string, minutes: number): string {
    const base = new Date(dateStr);
  
    // Add minutes normally
    const updated = new Date(base.getTime() + minutes * 60000);
  
    // Calculate total minutes since start of the day
    const diffMs = updated.getTime() - new Date(base.toDateString()).getTime();
    const totalMinutes = diffMs / 60000;
  
    const hours = Math.floor(totalMinutes / 60);
    const mins = Math.floor(totalMinutes % 60);
  
    // Format back as overflow time
    const hh = hours.toString().padStart(2, '0');
    const mm = mins.toString().padStart(2, '0');
  
    const datePart = dateStr.split("T")[0];
  
    return `${datePart}T${hh}:${mm}:00`;
  }

  hasZeroTime(dt: string): boolean {
    return dt.split("T")[1] === "00:00:00";
  }
  getTimesheetData() {
    
    this.ts.getTimeSheetById(this.timesheetId)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // console.log(res.data);
            // this.timeSheetData = res.data;

            // this.timesheetId = -2145145950;
            this.archive = res.data.isArchived;
            this.timeSheetCmnData = res.data.timeSheet;
            this.trainingComments = this.timeSheetCmnData.trainingComments;
            this.trainingCommentsDis = this.timeSheetCmnData.trainingComments;
            this.timeSheetData = res.data.lineItems.map((item: any) => {
            return {
              ...item,
              // Convert start/finish/breaks into HH:mm for direct binding
              startTime: this.toTimeString(item.startTime),
              startHour: ((item.isHoliday && item.startTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? '' : parseInt(this.toTimeString(item.startTime).split(":")[0]),
              startMinute: ((item.isHoliday && item.startTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? ''  : String(this.toTimeString(item.startTime).split(":")[1].padStart(2, '0')),
              startTimeOrg: item.startTime,
              
              difTime: this.getTimeDiffInMinutes(item.startTime, item.endTime),
              endHour: ((item.isHoliday && item.endTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? '' : parseInt(this.getTimeDiffInMinutes(item.startTime, item.endTime).split(":")[0]),
              endMinute: ((item.isHoliday && item.endTime == '1972-01-12T00:00:00') || (item.startTime == '1972-01-12T00:00:00')) ? '' : String(parseInt(this.getTimeDiffInMinutes(item.startTime, item.endTime).split(":")[1])).padStart(2, '0'),
              endTime: (item.endTime == '1972-01-12T00:00:00') ? '' : String(this.getTimeDiffInMinutes(item.startTime, item.endTime)).padStart(2, '0'),
              // endHour: (parseInt(this.toTimeString(item.endTime).split(":")[0]) == 0) ? '': parseInt(this.toTimeString(item.endTime).split(":")[0]),
              // endMinute: (String(parseInt(this.toTimeString(item.endTime).split(":")[1])).padStart(2, '0') === '00') ? '' : String(parseInt(this.toTimeString(item.endTime).split(":")[1])).padStart(2, '0'),
              endTimeOrg: item.endTime,
              breakMinutes: ((item.isHoliday && item.breakMinutes == 0) || (item.breakMinutes == 0)) ? '' : item.breakMinutes,
              midnightBreakMinutes: ((item.isHoliday && item.midnightBreakMinutes	 == 0) || (item.midnightBreakMinutes	 == 0)) ? '' : item.midnightBreakMinutes,
              markedForSubmit: false
            };
            });
            this.timeSheetTopPannel = res.data.timesheetSummary[0];
            this.jobOrderData = res.data.jobOrder;
            // console.log(this.timeSheetData);
            // console.log(this.timeSheetTopPannel.regular);
            // console.log(this.toTimeString("2025-04-02T04:00:00.000Z"));
            // console.log(this.toTimeString("2025-07-01T17:00:00"));
            this.hourDropDown = Array.from({ length: 24 }, (_, i) => String(i));
            this.endHourDropDown = Array.from({ length: 48 }, (_, i) => String(i));
            this.minuteDropDown = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));
            
            this.hourDropDown.unshift('');
            this.endHourDropDown.unshift('');
            this.minuteDropDown.unshift('');

            this.ts.getNoteTypes()
              .subscribe({
                next: (resNote: any) => {
                  if (resNote.status) {
                    // console.log(resNote.data);
                    this.noteTypes = resNote.data;
                  } else {
                    this.dashboard_msg = "dataRetriveErrorMessage";
                    this.msgType = "danger";           
                    this.isButtonDisabled = false;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                },
                error: (err: any) => {
                  if (err.status == 401) {
                    this.auth.logout();
					          return
                  } else {
                    this.dashboard_msg = "dataRetriveErrorMessage";
                    this.msgType = "danger";           
                    this.isButtonDisabled = false;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }
              });
            
            this.ts.getExpensesTypes()
              .subscribe({
                next: (resExpenses: any) => {
                  if (resExpenses.status) {
                    // console.log(resExpenses.data);
                    this.expensesTypes = resExpenses.data;
                  } else {
                    this.dashboard_msg = "dataRetriveErrorMessage";
                    this.msgType = "danger";           
                    this.isButtonDisabled = false;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                },
                error: (err: any) => {
                  if (err.status == 401) {
                    this.auth.logout();
					          return
                  } else {
                    this.dashboard_msg = "dataRetriveErrorMessage";
                    this.msgType = "danger";           
                    this.isButtonDisabled = false;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }
              });
          }
        },
        error: (err: any) => {
          if (err.status == 401) {
            this.auth.logout();
			      return
          } else {
            this.dashboard_msg = "dataRetriveErrorMessage";
            this.msgType = "danger";           
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
    })
  }

  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short' });
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric' });
  }  

ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      const table = ($('#attendanceTable') as any).DataTable();
      if (table) {
        table.destroy(true);
      }
    }
  }

  
  onSave(): void {
    this.isButtonDisabled = true;
    this.dashboard_msg = null;
    this.dashboard_err_msg = []; // reset previous errors

    const hasError = this.validateAllRows();
    // stop if any error found
    if (hasError) {
      const errMsg = this.translate.instant('VALIDATION_FAILED');
      alert(errMsg);
      return;
    } 
    // console.log(this.timeSheetData[0])
    // Prepare payload
    const details = this.timeSheetData.map((item: any) => ({
      timesheetLineItemId: item.timesheetLineItemId ?? 0,
      dayDate: item.dayDate ?? '',
      startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg),
      endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg)).toISOString() ?? '',      
      midnightBreakMinutes:  parseInt(item.midnightBreakMinutes, 10) ?? 0,
      breakMinutes:  parseInt(item.breakMinutes, 10) ?? 0,
      noteId: item.noteId ?? 0,
      expenseId: item.expenseId ?? 0,      
      status: item.markedForSubmit ? 20 : item.status,
      cost: parseInt(item.cost, 10) ?? 0,
      whf: item.whf ?? false,
      etcRemarks: item.etcRemarks ?? ''
    }));
    const comments = this.timeSheetCmnData.comments;
    // console.log(comments),
    const payload = {
      timesheetId: this.timesheetId, // Set this as needed
      details,
      comments: comments
    };
    
    // console.log(payload);
    // return;
    this.ts.saveTimeSheet(payload)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // console.log(res.message)
            this.dashboard_msg = res.message;//"dataSaveSuccesMessage";
            this.msgType = "success";
            this.getTimesheetData();
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "danger";
            this.getTimesheetData();
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          console.log(err.message);
          if (err.status == 401) { 
            this.auth.logout();
			      return
          }  else {
            this.dashboard_msg = "dataSaveErrorMessage";
            this.msgType = "danger";
            this.getTimesheetData();
            this.isButtonDisabled = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
    })
  }

  convertOverflowDate(dateStr: string): Date {
    // Remove trailing Z and split
    const [datePart, timePart] = dateStr.replace('Z', '').split('T');
  
    const baseDate = new Date(datePart);
    // Convert time part (25:00:00.000) into total milliseconds
    const [h, m, s] = timePart.split(':');
    const [sec, ms = "0"] = s.split('.');
  
    const totalMs =
      Number(h) * 3600000 +
      Number(m) * 60000 +
      Number(sec) * 1000 +
      Number(ms);
  
    // Add overflow time to date
    return new Date(baseDate.getTime() + totalMs);
  }

  scrollToRow(row: number) {
    $('.timeSheet_row').eq(row - 1)[0]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
  
  private addError(rowIndex: number, message: string, disDate: string = '') {
    const exists = this.dashboard_err_msg.some(
      e => e.row === rowIndex && e.message === message
    );

    if (!exists) {
      this.dashboard_err_msg.push({ row: rowIndex, message, disDate });
    }
  }

  validateAllRows(): boolean {
    const startTimeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
    const breakRegex = /^(?:0|[1-9]\d{0,2}|1[0-3]\d{2}|14[0-3]\d|1440)$/;
    this.dashboard_err_msg = [];                  
    let hasError = false;

    $(".timeSheet_row").each((i, row) => {
      if (this.validateRow($(row), i, startTimeRegex, breakRegex)) {
        hasError = true;
      }
    });

    return hasError;
  }
  
 
  validateRow($row: any, rowIndex: number, startTimeRegex: any, breakRegex: any): boolean {
    // console.log($row);
    
    let hasError = false;
    let txt = $row.find(".tbl_date strong").text().trim();
    let tableDate = txt.substring(0, txt.length / 2);
    // console.log(tableDate);
    let getStartHour = $row.find(".start_hour").val();
    let getStartMinute = $row.find(".start_minute").val();
    let getEndHour = $row.find(".end_hour").val();
    let getEndMinute = $row.find(".end_minute").val();
    var startHour = 0;
    var startMinute = 0;
    var endHour = 0;
    var endMinute = 0;
    if (getStartHour !== '') { startHour = parseInt(getStartHour, 10); }  
    if (getStartMinute !== '') { startMinute = parseInt(getStartMinute, 10); }
    if (getEndHour !== '') { endHour = parseInt(getEndHour, 10); }
    if (getEndMinute !== '') { endMinute = parseInt(getEndMinute, 10); }
    
    const breakTime = $row.find(".break_time").val();
    const mnBreakTime = $row.find(".mid_night_break").val();
    const noteVal = parseInt($row.find(".note").val());
    const expensesDropDwn = parseInt($row.find(".expenses").val())??'0';
    const expensesVal = $row.find(".cost").val();
    var flag = 0;
    if (getStartHour === '' || getStartMinute === '') {
      if (getEndHour !== '') {
        $row.find(".end_hour").addClass("is-invalid");
        this.addError(rowIndex + 1,'err1', tableDate); 
        flag++;
        hasError = true;
        // console.log("1")
      }
      if(getEndMinute !== '') {
        $row.find(".end_minute").addClass("is-invalid");
        this.addError(rowIndex + 1,'err1', tableDate); 
        flag++;
        hasError = true;
        // console.log("2")
      }
    }
    // console.log(breakTime) 
    if (getEndHour === '' || getEndMinute === '') {
      if (getStartHour !== '') {
        $row.find(".start_hour").addClass("is-invalid");
        this.addError(rowIndex + 1,'err2', tableDate); 
        flag++;
        hasError = true;
        // console.log("3")
      }
      if(getStartMinute !== '') {
        $row.find(".start_minute").addClass("is-invalid");
        this.addError(rowIndex + 1,'err2', tableDate); 
        flag++;
        hasError = true;
        // console.log("4")
      }
    }
    // console.log(getStartHour + " - " + getStartMinute + " || " + getEndHour + " - " + getEndMinute);
    var finalStart = parseInt('0', 10);
    var finalEnd = parseInt('0', 10);
    if (flag === 0) {
      if (getStartHour === '' && getStartMinute === '' && getEndHour === '' && getEndMinute === '') { 
        $row.find(".start_hour, .start_minute, .end_hour, .end_minute").removeClass("is-invalid");
      } else {
        // START TIME validation
        finalStart = (startHour * 60) + startMinute;
        finalEnd = (endHour * 60) + endMinute;      
        // console.log(finalStart+" - "+finalEnd);
        // Start should be <= End
        if (finalStart >= finalEnd) {
          $row.find(".start_hour, .start_minute, .end_hour, .end_minute").addClass("is-invalid");
          this.addError(rowIndex + 1,'err3', tableDate);  
          hasError = true;
          // console.log("5")
        } else {        
          // -----------------------------
          // OVERLAP VALIDATION
          // -----------------------------
          const prevRow = this.timeSheetData[rowIndex - 1];
          const nextRow = this.timeSheetData[rowIndex + 1];

          if (finalStart >= 0 && finalEnd > 0) {
            const curr = this.timeSheetData[rowIndex];
            const currStart = this.getAbsoluteMinutes(
                curr.dayDate,
                curr.startHour,
                curr.startMinute
              );

              const currEnd = this.getAbsoluteMinutes(
                curr.dayDate,
                curr.endHour,
                curr.endMinute
              );

              // --------------------
              // PREVIOUS ROW CHECK
              // --------------------
              const prev = this.timeSheetData[rowIndex - 1];
              if (prev) {
                const prevEnd = this.getAbsoluteMinutes(
                  prev.dayDate,
                  prev.endHour,
                  prev.endMinute
                );

                if (prevEnd >= 0 && currStart < prevEnd) {
                  $row.find(".start_hour, .start_minute").addClass("is-invalid");

                  this.addError(
                    rowIndex + 1,
                    'StartOverlap',
                    tableDate
                  );

                  hasError = true;
                }
              }

              // --------------------
              // NEXT ROW CHECK
              // --------------------
              const next = this.timeSheetData[rowIndex + 1];
              if (next) {
                const nextStart = this.getAbsoluteMinutes(
                  next.dayDate,
                  next.startHour,
                  next.startMinute
                );

                if (nextStart >= 0 && currEnd > nextStart) {
                  $row.find(".end_hour, .end_minute").addClass("is-invalid");

                  this.addError(
                    rowIndex + 1,
                    'EndOverlap',
                    tableDate
                  );

                  hasError = true;
                }
              }
            
          } else {
            $row.find(".start_hour, .start_minute, .end_hour, .end_minute").removeClass("is-invalid");
          }
        }
      }
      
    } else {
      $row.find(".start_hour, .start_minute, .end_hour, .end_minute").removeClass("is-invalid");
    }
    // console.log(finalEnd+' - '+finalStart)
    let workTime = (finalEnd - finalStart);
    // console.log(workTime);
    // BREAK TIME validation
    if (breakTime === "" || breakTime === undefined) {
        // allow blank
        $row.find(".break_time").removeClass("is-invalid");
    } else if (breakRegex.test(String(breakTime))) {
      if (parseInt(breakTime) >= workTime) {
        $row.find(".break_time").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err4', tableDate);
        hasError = true;
        // console.log("6")
      } else {
        $row.find(".break_time").removeClass("is-invalid");
      }
    } else {
      $row.find(".break_time").addClass("is-invalid");
      this.addError(rowIndex + 1, 'err5', tableDate);
      hasError = true;
      // console.log("7")
    }

    // MIDNIGHT BREAK validation
    if (mnBreakTime === "" || mnBreakTime === undefined) {
        // allow blank
        $row.find(".mid_night_break").removeClass("is-invalid");
    } else if (breakRegex.test(String(mnBreakTime))) {
      if (parseInt(mnBreakTime) > workTime) { 
        $row.find(".mid_night_break").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err6', tableDate);
        hasError = true;
        // console.log("8")
      } else {
        let MnWorkTime = (finalEnd - (22*60));
        console.log(MnWorkTime)
        if (mnBreakTime >= MnWorkTime) { 
          $row.find(".mid_night_break").addClass("is-invalid");
          this.addError(rowIndex + 1, 'err7', tableDate);
          hasError = true;
        } else {
          $row.find(".mid_night_break").removeClass("is-invalid");
        }
      }
    } else {
      $row.find(".mid_night_break").addClass("is-invalid");
      this.addError(rowIndex + 1, 'err8', tableDate);
      hasError = true;
      // console.log("9")
    }

    // NOTE (20) specific rule
    if (noteVal === 20 || noteVal === 50) {
      if (finalStart > 0) {
        $row.find(".start_hour, .start_minute").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err9', tableDate);
        hasError = true;
        // console.log("10")
      }
      if (finalEnd > 0) {
        $row.find(".end_hour, .end_minute").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err9', tableDate);
        hasError = true;
        // console.log("11")
      }
      if (parseInt(breakTime) > 0) {
        $row.find(".break_time").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err9', tableDate);
        hasError = true;
        // console.log("12")
      }
      if (parseInt(mnBreakTime) > 0) {
        $row.find(".mid_night_break").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err9', tableDate);
        hasError = true;
        // console.log("13")
      }
    }

    if (expensesDropDwn) {      
      if (expensesVal <= 0) {
        $row.find(".cost").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err10', tableDate);
        hasError = true;
        // console.log("14")
      } else {
        $row.find(".cost").removeClass("is-invalid");
      }
    } else {
      if (expensesVal > 0) {
        $row.find(".cost").addClass("is-invalid");
        this.addError(rowIndex + 1, 'err11', tableDate);
        hasError = true;
        // console.log("15")
      } else {
        $row.find(".cost").removeClass("is-invalid");
      }
    }
    return hasError;
  }
  
  private getAbsoluteMinutes(
    dayDate: string | Date,
    hour: number | string,
    minute: number | string
  ): number {

    if (hour === '' || minute === '' || hour == null || minute == null) {
      return -1;
    }

    const baseDate = new Date(dayDate);
    baseDate.setHours(0, 0, 0, 0);

    const h = +hour;
    const m = +minute;

    // each day = 1440 minutes
    const dayOffset = Math.floor(h / 24);
    const hourInDay = h % 24;

    return (
      baseDate.getTime() / 60000 +   // convert ms → minutes
      dayOffset * 1440 +
      hourInDay * 60 +
      m
    );
  } 
  toggleAllApprovals(event: Event) {
  const input = event.target as HTMLInputElement;
  const isChecked = input.checked;

  this.selectAll = isChecked; // update header state

  // Update all rows
  this.timeSheetData.forEach((item: any) => {
    if(item.status == 10)
    item.markedForSubmit = isChecked;
  });

    console.log('All Approve checkboxes set to:', isChecked);
  }
  onRowApproveChange() {
    this.selectAll = this.timeSheetData.every((item: any) => item.markedForSubmit);
  }
  editReject(index: number) {
    // console.log("here");
    this.editingRow = index;
    this.archive = true;
    this.expandedRows[index] = true;
    this.expandedRowsButton[index] = true;
  }

  cancelReject(index: number) {
    // console.log("cancel reject");
    this.editingRow = null;
    this.archive = false;
    this.selectAll = false;
    this.expandedRows[index] = false;
    this.expandedRowsButton[index] = false;
    this.getTimesheetData();
  }

  saveReject(index: number) {
    // console.log("save reject");
    const startTimeRegex = /^(?:[0-9]|[01][0-9]|2[0-3]):[0-9]|[0-5][0-9]$/;
    const breakRegex = /^(?:0|[1-9]\d{0,2}|1[0-3]\d{2}|14[0-3]\d|1440)$/;
    let hasError = false;
    // console.log(this.timeSheetData)
    const rowItem = [this.timeSheetData[index]];
    // console.log(rowItem);

    // const item = this.timeSheetData[index];
    const row = $("#timeSheet_row_" + index);
    hasError = this.validateRow(row, index, startTimeRegex, breakRegex);
    
    if (hasError) {
      const errMsg = this.translate.instant('VALIDATION_FAILED');
      alert(errMsg);
      return;
    } 
    // return;
    this.editingRow = null;
    
    const details = rowItem.map((item: any) => ({
      timesheetLineItemId: item.timesheetLineItemId ?? 0,
      dayDate: item.dayDate ?? '',
      startTime: this.toIsoString((item.startHour+':'+item.startMinute), item.startTimeOrg),
      endTime: this.convertOverflowDate(this.toIsoString((item.endHour+':'+item.endMinute), item.startTimeOrg)).toISOString() ?? '',
      midnightBreakMinutes:  parseInt(item.midnightBreakMinutes, 10) ?? 0,
      breakMinutes:  parseInt(item.breakMinutes, 10) ?? 0,
      noteId: item.noteId ?? 0,
      expenseId: item.expenseId ?? 0,      
      status: 20,
      cost: parseInt(item.cost, 10) ?? 0,
      whf: item.whf ?? false,
      etcRemarks: item.etcRemarks ?? ''
    }));

    const payload = {
      timesheetId: this.timesheetId,
      details
    };
       
    // console.log(payload);
    // return;
    this.ts.saveTimeSheet(payload)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // console.log(res.message)
            // const tableElement = $('#attendanceTable') as any;
            // if ($.fn.dataTable.isDataTable(tableElement)) {
            //     tableElement.DataTable().clear().destroy();
            //   }
            // this.getTimesheetData();
            // this.refreshPage();
            // console.log(this.router.url);
            // this.router.navigate([this.router.url]);
            this.dashboard_msg = res.message;//"dataSaveSuccesMessage";
            this.msgType = "success";
            this.archive = false;
            this.selectAll = false;
            this.expandedRows[index] = false;
            this.expandedRowsButton[index] = false;
            this.getTimesheetData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "error";
            this.archive = false;
            this.selectAll = false;
            this.expandedRows[index] = false;
            this.expandedRowsButton[index] = false;
            this.getTimesheetData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          console.log(err.message);
          if (err.status == 401) {
            this.auth.logout();
			      return	
          } else if (err.status === 409) {
            this.dashboard_msg = "dataConflictErrorMessage";
            this.msgType = "danger";
            this.ts.invalidateTimesheetDataCache(this.timesheetId);
            this.getTimesheetData();
          }
          this.archive = false;
          this.selectAll = false;
          this.expandedRows[index] = false;
          this.expandedRowsButton[index] = false;
        }
    })
    this.dashboard_err_msg = [];
  }
  refreshPage() {
    this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }
  /*----------- Timesheet format logic ------------*/
  getDayWeekKey(dateString: string): { day: string, weekdayKey: string, shortweekday: string } {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const weekdayIndex = date.getDay();

    const weekdayKeys = [
      'WEEKDAYS.SUNDAY',
      'WEEKDAYS.MONDAY',
      'WEEKDAYS.TUESDAY',
      'WEEKDAYS.WEDNESDAY',
      'WEEKDAYS.THURSDAY',
      'WEEKDAYS.FRIDAY',
      'WEEKDAYS.SATURDAY'
    ];

    const weekdayKeysShort = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    return { day, weekdayKey: weekdayKeys[weekdayIndex], shortweekday: weekdayKeysShort[weekdayIndex] };
  }

  getStatus(status: number): { statusKey: string } {
    let statusIndex = 0;
    if (status == 40) {
      statusIndex = 4;
    } else if (status == 30) {
      statusIndex = 3;
    } else if (status == 20) {
      statusIndex = 1;
    } else {
      statusIndex = 0;
    }
    const statusKeys = [
      "SHORTSTATUS.NOTSUBMIT",
      "SHORTSTATUS.SUBMIT",
      "SHORTSTATUS.FIX",
      "SHORTSTATUS.REJECT",
      "SHORTSTATUS.APPROVE"
    ];
    return {statusKey: statusKeys[statusIndex]}
  }

  getStartTime(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

 
  toTimeString(dateString: string): string {
    // console.log(dateString);
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const hours = date.getHours().toString();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  fncCng(event: any) {
    const target = event.target as HTMLSelectElement;
    this.timesheetId = target.value;
    this.timesheetIdOrg = Base64UrlService.encode(this.en.encryptionAES(this.timesheetId.toString()));
    this.getTimesheetData();
  }

  private toIsoString(time: any, originalIso: string): string {
    // console.log(time);
    if (typeof time === 'object' && time !== null) {      
      const date = new Date(time);
      const hours = date.getHours();
      const minutes = date.getMinutes();            
      time = `${String(hours)}:${String(minutes)}`;
    }
    // console.log(originalIso);
    if (time.split(":")[0] == '' && time.split(":")[1] == '') {
      originalIso = "1972-01-12T00:00:00"
    }
    const [hours, minutes] = time.split(':').map(Number);
    // const date = new Date(originalIso || new Date());
    // date.setHours(hours, minutes, 0);
    const date = new Date(originalIso || new Date());    
    // Create a new Date object with today's date and given time
    const yyyy = String(date.getFullYear());
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');  
    const hh = String(hours).padStart(2, '0');
    const min = String(minutes).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}T${hh}:${min}:00.000Z`;
  }

  
  getEndTime(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  getNote(note: number): { noteKey: string } {
    let statusIndex = 0;
    if (note == 10) {
      statusIndex = 0;
    } else if (note == 20) {
      statusIndex = 1;
    } else if (note == 40) {
      statusIndex = 2;
    } else if (note == 50) {
      statusIndex = 3;
    } else {
      statusIndex = 4;
    }
    const noteKeys = [
      "",
      "NOTEDD.PaidLeave",
      "NOTEDD.Tardiness",
      "NOTEDD.Absence",
      "NOTEDD.SeeComment"
    ];
    return {noteKey: noteKeys[statusIndex]}
  }
  
  getExpenses(expenses: number): { expensesKey: string } {
    let statusIndex = 0;
    if (expenses == 0) {
      statusIndex = 0;
    } else if (expenses == 1) {
      statusIndex = 1;
    } else if (expenses == 2) {
      statusIndex = 2;
    }
    const expensesKeys = [
      "",
      "ExpenseDD.AdvancePayment",
      "ExpenseDD.Transportation"
    ];
    return {expensesKey: expensesKeys[statusIndex]}
  }

  getClass(status: number): string {
    if(status == 10){
      return 'tr_non_submit';
    } else if(status == 20){
      return 'tr_submit';
    } else if(status == 30){
      return 'tr_reject';
    } else {
      return 'tr_approve';
    }
    
  }

  isBreakMinutesInvalid(item: any): boolean {
    return (
      item.breakMinutes === '' ||
      item.breakMinutes === null ||
      isNaN(item.breakMinutes) ||
      String(item.breakMinutes).trim() === ''
    );
  }

  toggleBelowRows(index: number): void {
    console.log(index);
    this.expandedRows[index] = !this.expandedRows[index];
    this.expandedRowsButton[index] = !this.expandedRowsButton[index];
  }

  onRejectClick(item: any): void {
    if (item.status === 30 || item.status === 20) {      
      // console.log(this.lang + " - - " + );item.timesheetLineItemId
      this.ts.getEtcThread(item.timesheetLineItemId, this.lang )
      .subscribe({
        next: (res: any) => {
            this.thread_msg = res;
            // console.log(this.thread_msg);
          },
          error: (err: any) => {
            console.log(err)
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })

    }
  }

  threadClose() {
    this.thread_msg = null;
  }

  formatDateTime(dateString: string): string {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' }); // "Oct"
    const day = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${year}-${month}-${day} : ${hours}:${minutes}`;
  }

  dwnPdf(id: any) {
    this.ts.getPdf(id )
      .subscribe({
        next: (res: any) => {
            const blob = new Blob([res.body ?? res], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
          },
          error: (err: any) => {
            console.log(err)
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }

  saveTraining() {    
      const now = new Date();
      const updateDate = now.toISOString();
      
      const payLoad =
      {
        "timesheetId": this.timesheetId,
        "trainingComments": this.trainingComments,
        "trainingCmtUpdateDate": updateDate
      }
      // const modalElement = document.getElementById('training_history_popup');
      // const modalInstance = bootstrap.Modal.getInstance(modalElement) 
      //   || new bootstrap.Modal(modalElement);
      
      this.ts.updateTrainingHistory(payLoad)
        .subscribe({
          next: (res: any) => {
            if (res.status) {
              // modalInstance.hide();
              // document.getElementById("btntraining_history_popup")?.click();
              this.triggerClick();
              // $("#btntraining_history_popup").click();
              this.getTimesheetData();
              // setTimeout(() => {
              //   document.body.classList.remove('modal-open');
              //   document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
              // }, 300);
            } else {
              alert(res.message);
            }
          },
          error: (err: any) => {
            console.log(err.message)
            if (err.status == 401) {
              this.auth.logout()
			        return
            }
          }
      })
    }

  reset() {
    this.dashboard_msg = null;
    this.dashboard_err_msg = [];
  }
}
